
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {TranslateModule} from "@ngx-translate/core";
import {CalendarComponent} from "./calendar.component";
import {EventDialogComponent} from "./dialog/eventDialog.component";
import {EventDetailsDialogComponent} from "./dialog/eventDetailsDialog.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {CalendarMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {RouterModule} from "@angular/router";
import {CalendarCommonModule, CalendarWeekModule} from "angular-calendar";
import {DayViewSchedulerComponent} from "./day-view-scheduler.component";
import {WorkersResolve} from "../user/workers.resolve";
import {ResourcesResolve} from "../resource/resources.resolve";
import {CustomCalendarWeekViewEventComponent} from "./custom-event-view.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import {ExitWithoutSaveDialogComponent} from "./dialog/exitWithoutSaveDialog.component";
import {DeleteEventDialogComponent} from "./dialog/deleteEventDialog.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {ResourceUsersResolve} from "../user/resourceUsersResolve.resolve";
import {GroupActivityComponent} from "./groupActivity.component";
import {GroupActivityResolve} from "./resolvers/groupActivity.resolve";
import {ReservationDataResolve} from "./resolvers/reservationData.resolve";
import {AddParticipantDialogComponent} from "./dialog/addParticipantDialog.component";
import {CalendarWorkersResolve} from "../user/resolvers/calendarWorkers.resolve";
import {CalendarResourceUsersResolve} from "../user/resolvers/calendarResourceUsersResolve.resolve";
import {DeleteParticipantDialogComponent} from "./dialog/deleteParticipantDialog.component";
import {ParticipantsListDialogComponent} from "./dialog/participantsListDialog.component";
import {ConfirmExerciseDialogComponent} from "./dialog/confirmExerciseDialog.component";

registerLocaleData(localePl);

@NgModule({
    declarations: [
        CalendarComponent,
        EventDialogComponent,
        EventDetailsDialogComponent,
        CalendarMainSidebarComponent,
        DayViewSchedulerComponent,
        CustomCalendarWeekViewEventComponent,
        ExitWithoutSaveDialogComponent,
        DeleteEventDialogComponent,
        GroupActivityComponent,
        AddParticipantDialogComponent,
        DeleteParticipantDialogComponent,
        ParticipantsListDialogComponent,
        ConfirmExerciseDialogComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTooltipModule,
        MatDialogModule,
        MatToolbarModule,
        TranslateModule,
        MatDatepickerModule,
        RouterModule,
        CalendarWeekModule,
        CalendarCommonModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
    ],
    providers: [
        WorkersResolve,
        CalendarWorkersResolve,
        ResourceUsersResolve,
        CalendarResourceUsersResolve,
        GroupActivityResolve,
        ReservationDataResolve,
    ],
    bootstrap: [
        CalendarComponent,
        EventDialogComponent,
        EventDetailsDialogComponent,
        ExitWithoutSaveDialogComponent,
        DeleteEventDialogComponent,
        GroupActivityComponent,
    ]
})
export class CalendarModule { }
